import React, {useEffect, useState} from "react";
import TextField from "@material-ui/core/TextField";
import FormLabel from "@material-ui/core/FormLabel";
import Button from "@material-ui/core/Button";
import {getCurrentDate} from "../../shared/util/util";
import Header from "./Header/Header";
import {useSelector} from "react-redux";
import emailService from "../../shared/services/emailService";
import IconButton from "@material-ui/core/IconButton";
import CloseIcon from "@material-ui/icons/Close";
import Snackbar from "@material-ui/core/Snackbar";
import {EMAIL_ERROR, EMAIL_REGEX, FIRST_NAME_ERROR, LAST_NAME_ERROR, NAME_REGEX} from "../../shared/constantsEN";
import Offer from "./Offers/offer";
import Analytics from "../../shared/util/analytics";

export default function Email() {
    const quoteImage = useSelector(state => state.cartReducer.blobOfCart);
    const RegexParser = require('regex-parser');
    const [snackPack, setSnackPack] = useState([]);
    const [messageInfo, setMessageInfo] = useState(undefined);
    const [open, setOpen] = useState(false);
    const analytics = Analytics();

    const [values, setValues] = useState({
        firstNameError: false,
        lastNameError: false,
        emailError: false,
        firstName: '',
        lastName: '',
        email: '',
        date: getCurrentDate('/')
    });

    const handleChangeForm = name => event => {
        setValues({...values, [name]: event.target.value})
    };

    const isDisabled = () => {
        return !(!values.firstNameError && !values.lastNameError && !values.emailError);
    };

    const verifyInput= name => event=> {
        if((name !== 'email') && !event.target.value.match(RegexParser(NAME_REGEX))){
            if(name === 'firstName'){
                setValues({...values,firstNameError:true})
            }else {
                setValues({...values,lastNameError:true})
            }
        }else if ((name === 'email') &&!event.target.value.match(RegexParser(EMAIL_REGEX))){
                setValues({...values,emailError:true})
        }else {
            if(name === 'firstName'){
                setValues({...values,firstNameError:false})
            }else if(name === 'lastName'){
                setValues({...values,lastNameError:false})
            }else {
                setValues({...values,emailError:false})
            }
        }
    };

    const handleSubmit = event => {
        event.preventDefault();
        emailService.postEmail(values.date, values.firstName, values.lastName, values.email, quoteImage);

        const message = `Sent email to ${values.email}`;
        setSnackPack((prev) => [...prev, {message, key: new Date().getTime()}]);

    };

    const handleClose = (event, reason) => {
        if (reason === 'clickaway') {
            return;
        }

        setOpen(false);
    };

    const handleExited = () => {
        setMessageInfo(undefined);
    };

    useEffect(() => {
        analytics.trackPage('email');
    }, [analytics]);

    useEffect(() => {
        if (snackPack.length && !messageInfo) {
            setMessageInfo({...snackPack[0]});
            setSnackPack((prev) => prev.slice(1));
            setOpen(true);
        } else if (snackPack.length && messageInfo && open) {
            setOpen(false);
        }
    }, [snackPack, messageInfo, open]);

    return (
        <div>
            <Offer/>
            <br/>
            <Header title='Email Quote' page='cart'/>
            <div className="emailQuoteDisplay">
                <div className="headerEmail">Email Quote</div>
                <br/>
                <form className={"emailForm"} autoComplete="off" onSubmit={handleSubmit}>
                    <FormLabel component="title">EMAIL QUOTE</FormLabel>
                    <div className="emailminiheader" >
                        <TextField
                            id="first-name-filled-input"
                            className="stat-input-field"
                            data-dtm="email quote"
                            error={values.firstNameError}
                            helperText={FIRST_NAME_ERROR}
                            label="First Name"
                            variant="filled"
                            value={values.firstName}
                            onBlur={verifyInput('firstName')}
                            required
                            onChange={handleChangeForm('firstName')}
                            inputProps={{maxLength: 32}}/>
                        <br/>
                    </div>
                    <br/>
                    <div className="emailminiheader">
                        <TextField
                            id="last-name-filled-input"
                            className="stat-input-field"
                            data-dtm="email quote"
                            error={values.lastNameError}
                            helperText={LAST_NAME_ERROR}
                            label="Last Name"
                            variant="filled"
                            value={values.lastName}
                            onBlur={verifyInput('lastName')}
                            required
                            onChange={handleChangeForm('lastName')}
                            inputProps={{maxLength: 32}}/>
                        <br/>
                    </div>
                    <br/>
                    <div className="emailminiheader">
                        <TextField
                            id="email-filled-input"
                            className="stat-input-field"
                            data-dtm="email quote"
                            error={values.emailError}
                            helperText={EMAIL_ERROR}
                            label="Email"
                            variant="filled"
                            value={values.email}
                            onBlur={verifyInput('email')}
                            required
                            onChange={handleChangeForm('email')}
                            inputProps={{maxLength: 32}}/>
                        <br/>
                    </div>
                    <br/>
                    <div className="emailminiheader hide-on-mobile">
                        <TextField id="date-filled-disabled-input" label="Date" defaultValue={values.date}
                                   variant="filled" disabled/>
                        <br/>
                        <br/>
                    </div>
                    <div className="emailminiheader hide-on-desktop">
                        <div className="date">{values.date}</div>
                        <br/>
                    </div>
                    <Button className="button primary-button stat-button-link" data-dtm="email quote"
                            variant="outlined" color="primary" type="submit"
                            disabled={isDisabled()}>Send Quote</Button>
                </form>
                <Snackbar key={messageInfo ? messageInfo.key : undefined}
                          open={open}
                          autoHideDuration={6000}
                          onClose={handleClose}
                          onExited={handleExited}
                          message={messageInfo ? messageInfo.message : undefined}
                          action={
                              <>
                                  <IconButton
                                      aria-label="close"
                                      color="inherit"
                                      onClick={handleClose}>
                                      <CloseIcon/>
                                  </IconButton>
                              </>
                          }
                />
            </div>
        </div>
    )
}
